export default "__VITE_ASSET__BbvDyUsU__"